import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { SalesChannel } from '../../entities/control-tables/sales-channel';
import { UserInfo } from 'src/app/tools/models/entities/user-info';

export class SalesChannelRequest extends BaseRequest {

    salesChannel : SalesChannel;

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.salesChannel = new SalesChannel()
  }
}